import React from 'react'
import ClientSuspense from '@components/ClientSuspense'
import JustoLogo from '@components/JustoLogo'
import LoadingText from '@components/LoadingText'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'
import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

export function PoweredByJustoInner() {
  const websiteId = useWebsiteId()
  const {website} = useQuery({
    query: gql`
      query CheckoutV3JustoLogoSettings($websiteId: ID!) {
        website(websiteId: $websiteId) {
          _id
          checkoutHidePoweredBy
        }
      }
    `,
    variables: {websiteId},
    fetchPolicy: 'cache-first'
  })
  const darkMode = useIsDarkMode()

  if (!website) return null
  if (website.checkoutHidePoweredBy === true) return null
  return (
    <div className="flex items-center justify-center p-6 ">
      <a
        className="flex items-center opacity-50 hover:opacity-90 transition-all ease-in-out duration-150 hover:!no-underline"
        href="https://getjusto.com"
        target="_blank"
        rel="noreferrer">
        <span
          className={classnames({
            'text-xs font-normal mr-2': true,
            'text-black': !darkMode,
            'text-white': darkMode
          })}>
          Powered by
        </span>
        <JustoLogo height={18} />
      </a>
    </div>
  )
}

export default function PoweredByJusto() {
  return (
    <ClientSuspense fallback={<LoadingText />}>
      <PoweredByJustoInner />
    </ClientSuspense>
  )
}
